import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import {
  createResponseProject,
  getResponseProjects,
} from '../../../../../shared/api/magellan/responseProject';

export function useCreateResponseProjectMutation(options?: {
  onSuccess?: () => void;
}) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createResponseProject,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [getResponseProjects.name] });
      options?.onSuccess?.();
      navigate(`/response/projects/${data.id}`);
    },
  });
}
